import { render, staticRenderFns } from "./page404.vue?vue&type=template&id=a1236024&scoped=true&"
import script from "./page404.vue?vue&type=script&lang=js&"
export * from "./page404.vue?vue&type=script&lang=js&"
import style0 from "./page404.vue?vue&type=style&index=0&id=a1236024&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1236024",
  null
  
)

export default component.exports